const timeDate = require('../../../../../js-handler/time-date')

const inventoryDt      = require('./item-dt')
const inventorySnack   = require('./item-snack')
const reportInventory  = require ('./item-report-item-available')

export function getTimeSensitiveStyle(elem) {

    let icon = "";
    if (elem.shelf_life == "0" || elem.shelf_life == "") {
        icon = { color: 'td-gray-icon', svg: 'check-round' };
    } else {
        icon = { color: 'td-green-icon', svg: 'check-round' };
    }

    return icon;
}

export function getTimeTemperatureStyle(elem) {

    let icon = "";
    if (elem.temperature == "") {
        icon = { color: 'td-gray-icon', svg: 'check-round' };
    } else {
        icon = { color: 'td-green-icon', svg: 'check-round' };
    }

    return icon;
}

// funcion para actualizar el selling price del item seleccionado en los purchase que este incluido y que tengan inventario
export function updateSellingPrice(detail) {

    let dbid = detail.dbid;
    let newSellingPrice = detail.newSellingPrice;
    let item_unit_id = detail.item_unit_id;

    if (dbid == undefined || dbid == "" || dbid == null) {
        return;
    }
    if (newSellingPrice == undefined || newSellingPrice == "" || newSellingPrice == null) {
        return;
    }

    const formData = new FormData();
    formData.append('item_id', dbid);
    formData.append('item_unit_id', item_unit_id);
    formData.append('newSellingPrice', newSellingPrice);

    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = {
        method: 'POST',
        body: formData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    fetch(`./server/php/sql/updatePurchaseItemSellingPrice.php`, options)
        .then(result => result.json())
        .then(result => {
            if (result.error.val == "error") {
                inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
            } else {
                inventorySnack.start({ act: 'show', id: 'SuccessUpdate' });
                let reportPage = document.getElementById('report-page-right');
                if (reportPage != null && reportPage != undefined && !reportPage.classList.contains('dn')) {
                    reportInventory.start({ "dest": "item", "elem": "report", "reportType": "reportItemAvailable", "entity": "item" })
                } else {
                    inventoryDt.start({ "dest": "item", "elem": "dt", "act": "select", "entity": "item" })
                }
                //  {"dest":"inventory", "elem":"report", "reportType":"reportItemAvailable", "entity":"inventory"} 
            }
        })
        .catch(error => {
            inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
        });
}